import get from 'lodash.get';

const getSegmentIoKey = (rootState) => get(rootState, 'config.myyola.segmentio.write_key', null);

export default getSegmentIoKey;
